type Props = {
  message: string | undefined;
  propertyName?: string;
  itemName?: string;
};

export const getReadableRJSFErrors = ({
  message,
  propertyName
}: Props): string => {
  if (!message) return 'Unknown error';

  // Specific case for required field errors
  if (
    propertyName &&
    message === `must have required property '${propertyName}'`
  ) {
    return ' is required.';
  }
  if (
    message === 'must be equal to one of the allowed values' ||
    message === 'must be equal to constant'
  ) {
    return ' must be equal to one of the allowed values.';
  }

  const greaterThanOrEqualMatch = message.match(/^must be >= (.+)$/);
  if (greaterThanOrEqualMatch) {
    return `'s value must be greater than or equal to ${greaterThanOrEqualMatch[1]}.`;
  }

  const greaterThanMatch = message.match(/^must be > (.+)$/);
  if (greaterThanMatch) {
    return `'s value must be greater than ${greaterThanMatch[1]}.`;
  }

  return ` ${message}`;
};
